import ModalDialog from "@mui/joy/ModalDialog";
import DialogTitle from "@mui/joy/DialogTitle";
import Stack from "@mui/joy/Stack";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Modal from "@mui/joy/Modal";
import { get_brand_name_without_pagination, upload_image } from "../../reduxData/user/userAction";
import { useEffect, useState, useCallback, memo } from "react";
import {
  get_genders,
  get_regions,
  get_size_category,
  edit_sizes_features,
} from "../../reduxData/user/userAction";
import { get_brand_name } from "../../reduxData/user/userAction";
import { get_types } from "../../reduxData/user/userAction";
import { size_with_price } from "../../reduxData/user/userAction";
import { add_sizes } from "../../reduxData/user/userAction";
import { toast } from "react-toastify";

const CustomModal = memo(
  ({
    open,
    setApi,
    api,
    setOpen,
    setApiCall,
    setDefaultText,
    defaultText,
    Gender,
    Brand,
    Category,
    Region,
    frontTableData,
    frontSelectedBrand,
    frontSelectedCategory,
    frontSelectedGender,
    disableCategory,
    setDisableCategory,
    editRow,
    setEditRow,
    disableFields,
  }) => {
    const [language, setLang] = useState("English");
    const lang = ["English", "Arabic"];

    const [text, setText] = useState("XS");
    // console.log("region",Region);

    const [error, setError] = useState({
      gender: true,
      brand: true,
      category: true,
    });
    const [savedSizes, setSavedSizes] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState([]);
    const [region, setRegion] = useState([]);
    const [sizeCategory, setSizeCategory] = useState([]);
    const [selectedSizeCategory, setSelectedSizeCategory] = useState([]);
    const [selectedGender, setSelectedGender] = useState("");
    const [genders, setGenders] = useState([]);

    const [brands, setBrands] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState("");

    const [types, setTypes] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("");

    const handleSelectGender = useCallback((e) => {
      const data = e.target.value;
      setError((prev) => ({ ...prev, gender: false }));
      setSelectedGender(data);
    }, []);

    const handleGender = async () => {
      const res = await get_genders();
      const filterGender = res?.data?.filter((i) => i?.is_deleted === false);
      setGenders(filterGender?.filter((i) => i?.name));
    };
    const handleSizeCategory = async () => {
      const res = await get_size_category();
      const filterData = res?.data?.filter((i) => i?.is_active);
      setSizeCategory(filterData);
    };

    const handleRegion = async () => {
      const res = await get_regions();
      const filterRegion = res?.data?.filter((i) => i?.is_active);
      setRegion(filterRegion);
    };

    const handleBrands = async () => {
      const res = await get_brand_name_without_pagination();
      const filterBrand = res?.data?.filter((i) => i?.is_deleted === false);
      setBrands(filterBrand);
      // setSelectedBrand(res?.data?.[0]?.id)
    };

    const handleSelectBrand = useCallback((e) => {
      const data = e.target.value;
      setError((prev) => ({ ...prev, brand: false }));
      setSelectedBrand(data);
    });

    const handleSelectCategory = useCallback((e) => {
      const data = e.target.value;
      setError((prev) => ({ ...prev, category: false }));
      setSelectedCategory(data);
    }, []);

    const fetchTypes = useCallback(async () => {
      const res = await get_types();
      if (res?.data) {
        const filtertypes = res?.data?.filter((i) => i?.is_deleted === false);
        setTypes(filtertypes);
      }
    }, []);

    console.log("selectedSizeCategory", selectedSizeCategory);
    useEffect(() => {
      if (disableCategory) {
        // setSelectedSizeCategory(SizeCategory);
        // console.log("Region +++ ",Region , region);
        const defaultExists = Region?.flat()?.[0];
        // console.log("default exists",defaultExists)
        if (defaultExists == 0) {
          const reg = [
            {
              region: "Default",
              region_ar: "پیش فرض",
              id: 0,
            },
          ];
          // console.log("check ",reg)
          setSelectedRegion(reg);
          return;
        }
        const reg = Region?.flat()?.map((i) =>
          region?.find((ii) => ii?.id == i)
        );
        setSelectedRegion(reg);
        // console.log("Region --- ",reg)
      }
      //  setSelectedRegion(reg)
    }, [disableCategory, region]);

    // console.log("SECLTED REGIONS",selectedRegion)

    const handleAddSizesApi = async () => {
      let payload = {};
      const checkDublicate = frontTableData?.find(
        (i) =>
          i?.gender_id == selectedGender &&
          i?.type_id == selectedCategory &&
          i?.brand_id == selectedBrand
      );
      // if (checkDublicate) {
      //   toast.error("This pair already exist ! Select different pair");
      //   return;
      // }

      if (defaultText) {
        const ids = selectedSizeCategory?.map((i) => ({
          id: i?.id,
          category_name: i?.region,
        }));
        payload = {
          size: selectedSizeCategory?.map((i) => ({
            gender_id: selectedGender,
            type_id: selectedCategory,
            brand_id: selectedBrand,
            category_id: i?.id,
            category_ids: ids,
            region_id: selectedRegion?.map((i) => i?.id),
            size_text: [
              selectedRegion?.map((i) => ({
                text: "s",
                text_ar: "س",
                region: i?.id,
              })),
            ],
          })),
        };

        // return;
      } else {
        payload = {
          size: savedSizes?.map((i) => ({
            gender_id: selectedGender,
            type_id: selectedCategory,
            brand_id: selectedBrand,
            category_id: String(i?.category_id),
            region_id: selectedRegion?.map((i) => i?.id),
            size_text: [i?.size_text],
          })),
        };
      }
      console.log("payload is  ", payload);

      const res = await add_sizes(payload);
      if (res) {
        // handleGetSize(selectedCategory);
        // setAddSizesLines([]);
        setApiCall((prev) => !prev);
        setEditRow(false);
        setApi("");
        setOpen(false);
        setDefaultText(false);
        frontSelectedBrand("");
        frontSelectedCategory("");
        frontSelectedGender("");
        setDisableCategory(false);
        setSelectedSizeCategory([]);
        setSelectedRegion([]);
      }
    };

    const handleEditSizesApi = async () => {
      const ids = selectedSizeCategory?.map((i) => ({
        id: i?.id,
        category_name: i?.region,
      }));

      const test = selectedSizeCategory?.map((i) => {
        let exists = savedSizes?.find((ii) => i?.id == ii?.category_id);
        let sizeId = exists;

        if (exists) {
          exists = selectedRegion?.map((regionItem) => {
            const regionExists = sizeId?.size_text?.find(
              (size) => size?.region == regionItem?.id
            );

            return (
              regionExists ?? {
                text: "s",
                text_ar: "",
                region: regionItem?.id,
              }
            );
          });
        }

        return {
          new_type_id: selectedCategory,
          new_brand_id: selectedBrand,
          new_gender_id: selectedGender,
          old_type_id: Category,
          old_brand_id: Brand,
          old_gender_id: Gender,
          category_id: i?.id,
          size_id: sizeId?.size_id,
          category_ids: ids,
          region_id: selectedRegion?.map((r) => r?.id),
          size_text:
            exists ??
            selectedRegion?.map((r) => ({
              text: "s",
              text_ar: "",
              region: r?.id,
            })),
        };
      });

      console.log("generated data", test);

      const editList = [];
      const addList = [];

      (test || []).forEach((item) => {
        if (item?.size_id) {
          editList.push(item);
        } else {
          addList.push(item);
        }
      });

      let editRes = [];
      let addRes = [];

      if (editList.length) {
        editRes = await Promise.all(
          editList.map((i) => {
            const payload = { size: [i] };
            return edit_sizes_features(payload);
          })
        );
      }

      if (addList.length) {
        const payload = {
          size: addList.map((i) => ({
            gender_id: i.new_gender_id,
            type_id: i.new_type_id,
            brand_id: i.new_brand_id,
            category_id: String(i.category_id),
            region_id: i.region_id,
            size_text: [i.size_text],
          })),
        };

        console.log("add payload", payload);
        addRes = await add_sizes(payload);
      }

      console.log("edit response", editRes);
      console.log("add response", addRes);
      setApiCall((prev) => !prev);
      setOpen(false);
      setEditRow(false);
      setApi("");
      setDefaultText(false);
      frontSelectedBrand("");
      frontSelectedCategory("");
      frontSelectedGender("");
      setDisableCategory(false);
      setSelectedSizeCategory([]);
      setSelectedRegion([]);

      console.log("payload", payload);
    };

    const handleGetSize = useCallback(async (cat, brand, gender) => {
      const res = await size_with_price(cat, brand, gender);
      const filterData = res?.data?.filter((i) => !i?.size_deleted);
      const unique = [];
      filterData?.forEach((i) => {
        if (!unique?.find((ii) => ii?.id == i?.category_id)) {
          unique.push({
            id: i?.category_id,
            region: i?.category_name || "Default",
            region_ar: i?.category_name_ar,
          });
        }
      });
      console.log("filtere category", unique);
      setSelectedSizeCategory(unique || []);

      setSavedSizes(filterData);
    }, []);

    const handleSelectRegion = (e) => {
      const value = JSON.parse(e.target.value);

      if (value?.id == 0) {
        toast.warning("Incase of Default only one value can be accepted");
        setSelectedRegion([value]);
        return;
      }

      setSelectedRegion((prev) => {
        const defaultValue = selectedRegion?.find((i) => i?.id == 0);
        if (defaultValue) return [value];
        const exists = prev?.find((r) => r.id === value.id);
        if (exists) return prev;

        return [...prev, value];
      });
    };

    const handleSelectSizeCategory = (e) => {
      const value = JSON.parse(e.target.value);
      if (value?.id == 0) {
        toast.warning("Incase of Default only one value can be accepted");
        setSelectedSizeCategory([value]);
        return;
      }

      setSelectedSizeCategory((prev) => {
        const defaultValue = selectedSizeCategory?.find((i) => i?.id == 0);
        if (defaultValue) return [value];
        const exists = prev.find((r) => r.id === value.id);
        if (exists) return prev;

        return [...prev, value];
      });
    };

    const handleRemoveRegion = (id) => {
      const removeRegion = selectedRegion?.filter((i) => i?.id != id);
      setSelectedRegion(removeRegion);
    };

    const handleRemoveSizeCategory = (id) => {
      const removeCategory = selectedSizeCategory?.filter((i) => i?.id != id);
      setSelectedSizeCategory(removeCategory);
    };

    useEffect(() => {
      handleGender();
      handleBrands();
      handleSizeCategory();
      handleRegion();
      fetchTypes();
      if (disableCategory) handleGetSize(Category, Brand, Gender);
    }, []);
    useEffect(() => {
      if (disableCategory) {
        setError((prev) => ({ ...prev, category: false }));

        // setSelectedCategory([SizeCategory]);
        // setSelectedSizeCategory
      }
    }, [disableCategory]);

    useEffect(() => {
      if (editRow) {
        setSelectedCategory(Category);
        setSelectedBrand(Brand);
        setSelectedGender(Gender);
      }
    }, [editRow]);

    console.log("selcted lang", language);

    return (
      <Modal open={open} onClose={() => setOpen(false)}>
        <ModalDialog
          sx={{
            padding: 4,
            width: {
              xs: "90vw",
              sm: "600px",
              md: "600px",
              lg: "600px",
            },
          }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <DialogTitle>{defaultText}</DialogTitle>
            {
              <div className="d-flex justify-content-end gap-1">
                {lang?.map((value, index) => (
                  <button
                    key={index}
                    onClick={() => setLang(value)}
                    className={`btn btn-sm rounded-pill d-flex align-items-center gap-2 px-3
      ${
        language === value
          ? "btn-primary active-lang hindi-btn text-white"
          : "hindi-btn"
      }`}
                  >
                    {value}
                  </button>
                ))}
              </div>
            }
          </div>
          <div>
            <p className="mb-0 fw-bold my-2">
              Product Category<span className="text-danger">*</span>
            </p>
            <select
              className="form-select cursor-pointer"
              value={selectedCategory}
              onChange={handleSelectCategory}
              defaultValue={""}
            >
              <option value="" disabled>
                {language == "English"
                  ? "Select Category"
                  : "دسته را انتخاب کنید"}
              </option>
              {types?.map((type) => (
                <option
                  className=" text-capitalize cursor-pointer text-capitalize"
                  key={type.id}
                  value={type?.id}
                >
                  {language == "English"
                    ? type?.type_name
                    : type.name_ar || type?.type_name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <p className="m-0 fw-bold ">
              {" "}
              Gender<span className="text-danger">*</span>
            </p>
            <select
              className="form-select cursor-pointer"
              value={selectedGender}
              onChange={handleSelectGender}
              defaultValue={""}
            >
              <option value="" disabled>
                {language == "English" ? "Select Gender" : "اختر الجنس"}
              </option>
              {/* <option value="1">
              men
            </option>
            <option value="2">Women</option> */}
              {genders?.map((i) => (
                <option value={i?.id} className="cursor-pointer">
                  {language == "English" ? i?.name : i.name_ar || i?.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <p className="m-0 fw-bold">
              {" "}
              Brands<span className="text-danger">*</span>
            </p>
            <select
              className="form-select cursor-pointer"
              value={selectedBrand}
              onChange={handleSelectBrand}
              defaultValue={""}
            >
              <option value="" disabled>
                {language == "English"
                  ? "Select Brand"
                  : "نام تجاری را انتخاب کنید"}
              </option>
              <option value="0">
                {language == "English" ? "Default" : "پیش فرض"}
              </option>
              {brands?.map((i) => (
                <option value={i?.id} className="cursor-pointer">
                  {language == "English"
                    ? i?.brand_name
                    : i?.brand_name_ar || i?.brand_name}
                </option>
              ))}
            </select>
          </div>
          {/* SIZE CATEGORY START  */}
          {
            <div>
              <p className="m-0 fw-bold">
                Category <span className="text-danger">*</span>
              </p>

              <select
                className="form-select cursor-pointer"
                onChange={handleSelectSizeCategory}
                value={""}
                disabled={disableFields}
                //  disabled={disableCategory}
              >
                <option value="" disabled>
                  {language == "English"
                    ? "Select Category"
                    : "دسته را انتخاب کنید"}
                </option>
                <option
                  value={JSON.stringify({
                    id: 0,
                    region: "Default",
                    region_ar: "پیش فرض",
                  })}
                >
                  {language == "English" ? "Default" : "پیش فرض"}
                </option>

                {sizeCategory?.map((i) => {
                  const isSelected = selectedSizeCategory?.some(
                    (r) => r.id === i.id
                  );

                  return (
                    <option
                      key={i.id}
                      value={JSON.stringify({
                        id: i.id,
                        region: i.category_name,
                        region_ar: i?.category_name_ar,
                      })}
                      disabled={isSelected}
                      className="cursor-pointer"
                    >
                      {language == "English"
                        ? i.category_name
                        : i?.category_name_ar || i.category_name}
                    </option>
                  );
                })}
              </select>

              <div className=" d-flex flex-wrap gap-3 mt-3 position-relative">
                {selectedSizeCategory?.map((i) => (
                  <button
                    key={i.id}
                    className=" border-1 border-dark rounded-2  bg-transparent px-2 py-1"
                  >
                    {language == "English"
                      ? i.region
                      : i?.region_ar || i.region || i?.category_name_ar}
                    {/* {disableCategory && (
                  <i
                    class="bi bi-x-circle-fill text-danger position-absolute cursor-pointer delete-region"
                    onClick={() => {
                      handleRemoveSizeCategory(i?.id);
                    }}
                  ></i>
                )}
               */}
                    {!disableFields && (
                      <i
                        class="bi bi-x-circle-fill text-danger position-absolute cursor-pointer delete-region"
                        onClick={() => {
                          handleRemoveSizeCategory(i?.id);
                        }}
                      ></i>
                    )}
                  </button>
                ))}
              </div>
            </div>
          }

          {/* SIZE CATEGORY END  */}
          {/* REGION START */}
          {
            <div>
              <p className="m-0 fw-bold">
                Region <span className="text-danger">*</span>
              </p>

              <select
                className="form-select cursor-pointer"
                onChange={handleSelectRegion}
                value=""
                disabled={disableFields}
                // disabled={disableCategory}
              >
                <option value="" disabled>
                  {language == "English"
                    ? "Select Region"
                    : "منطقه را انتخاب کنید"}
                </option>
                <option
                  value={JSON.stringify({
                    id: 0,
                    region: "Default",
                    region_ar: "پیش فرض",
                  })}
                >
                  {language == "English" ? "Default" : "پیش فرض"}
                </option>

                {region?.map((i) => {
                  const isSelected = selectedRegion?.some(
                    (r) => r?.id === i?.id
                  );

                  return (
                    <option
                      key={i.id}
                      value={JSON.stringify({
                        id: i.id,
                        region: i.region,
                        region_ar: i?.region_ar,
                      })}
                      disabled={isSelected}
                      className="cursor-pointer"
                    >
                      {language == "English"
                        ? i.region
                        : i?.region_ar || i.region}
                    </option>
                  );
                })}
              </select>

              <div className=" d-flex flex-wrap gap-3 mt-3 position-relative">
                {selectedRegion?.map((i) => (
                  <button
                    key={i?.id}
                    className="border-1 border-dark rounded-2  bg-transparent px-2 py-1"
                  >
                    {language == "English"
                      ? i?.region
                      : i?.region_ar || i?.region}
                    {/* {disableCategory && (
                  <i
                    class="bi bi-x-circle-fill text-danger position-absolute cursor-pointer delete-region"
                    onClick={() => handleRemoveRegion(i?.id)}
                  ></i>
                )} */}

                    {!disableFields && (
                      <i
                        class="bi bi-x-circle-fill text-danger position-absolute cursor-pointer delete-region"
                        onClick={() => handleRemoveRegion(i?.id)}
                      ></i>
                    )}
                  </button>
                ))}
              </div>
            </div>
          }
          {/* REGION END */}

          {/* {defaultText && <div>
        <p className="m-0 fw-bold">
            {" "}
         Default Text
          </p>
          <input value={text} onChange={(e) => setText(e.target.value)} className="form-control"/>
        </div>
        } */}

          <div className="text-end">
            <button
              className="btn btn-primary mt-2 "
              onClick={api == "add" ? handleAddSizesApi : handleEditSizesApi}
              // disabled={editRow? "":
              //   error?.gender ||
              //   error?.category ||
              //   error?.brand ||
              //   selectedSizeCategory.length === 0 ||
              //   selectedRegion.length === 0
              // }
            >
              Submit
            </button>
          </div>
        </ModalDialog>
      </Modal>
    );
  }
);

export default CustomModal;

// import ModalDialog from "@mui/joy/ModalDialog";
// import DialogTitle from "@mui/joy/DialogTitle";
// import Stack from "@mui/joy/Stack";
// import FormControl from "@mui/joy/FormControl";
// import FormLabel from "@mui/joy/FormLabel";
// import Input from "@mui/joy/Input";
// import Modal from "@mui/joy/Modal";
// import { upload_image } from "../../reduxData/user/userAction";
// import { useEffect, useState, useCallback } from "react";
// import {
//   get_genders,
//   get_regions,
//   get_size_category,
//  edit_sizes_features
// } from "../../reduxData/user/userAction";
// import { get_brand_name } from "../../reduxData/user/userAction";
// import { get_types } from "../../reduxData/user/userAction";
// import { size_with_price } from "../../reduxData/user/userAction";
// import { add_sizes } from "../../reduxData/user/userAction";
// import { toast } from "react-toastify";

// const CustomModal = ({
//   open,
//   setOpen,
//   setApiCall,
//   setDefaultText,
//   defaultText,
//   inputAttribute,
//   setInputAttribute,
//   handleAddAttribute,
//   title = "Add Type",
//   label = "Type Name",
//   placeholder = "Enter name",
//   Gender,
//   Brand,
//   Category,
//   SizeCategory,
//   Region,
//   availableRegions,
//   subtype,
//   setSubType,
//   show,
//   code,
//   frontTableData,
//   frontSelectedBrand,
//   frontSelectedCategory,
//   frontSelectedGender,
//   disableCategory,
//   setDisableCategory,
//   editRow,
//   setEditRow
// }) => {
//   const [language, setLang] = useState("English");
//   const lang = ["English", "Arabic"];

//   const [text, setText] = useState("XS");

//   const [error, setError] = useState({
//     gender: true,
//     brand: true,
//     category: true,
//   });
//   const [savedSizes, setSavedSizes] = useState([]);
//   const [selectedRegion, setSelectedRegion] = useState([]);
//   const [region, setRegion] = useState([]);
//   const [sizeCategory, setSizeCategory] = useState([]);
//   const [selectedSizeCategory, setSelectedSizeCategory] = useState([]);
//   const [selectedGender, setSelectedGender] = useState("");
//   const [genders, setGenders] = useState([]);

//   const [brands, setBrands] = useState([]);
//   const [selectedBrand, setSelectedBrand] = useState("");

//   const [types, setTypes] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState("");

//   const handleSelectGender = useCallback((e) => {
//     const data = e.target.value;
//     setError((prev) => ({ ...prev, gender: false }));
//     setSelectedGender(data);
//   }, []);

//   const handleGender = async () => {
//     const res = await get_genders();
//     const filterGender = res?.data?.filter((i) => i?.is_deleted === false)
//     setGenders(filterGender);
//   };
//   const handleSizeCategory = async () => {
//     const res = await get_size_category();
//     const filterData = res?.data?.filter((i) => i?.is_active );
//     setSizeCategory(filterData);
//   };

//   const handleRegion = async () => {

//     const res = await get_regions();
//     const filterRegion = res?.data?.filter((i) => i?.is_active);
//     setRegion(filterRegion);
//   };

//   const handleBrands = async () => {
//     const res = await get_brand_name();
//     const filterBrand = res?.data?.filter((i) => i?.is_deleted === false);
//     setBrands(filterBrand);
//     // setSelectedBrand(res?.data?.[0]?.id)
//   };

//   const handleSelectBrand = useCallback((e) => {
//     const data = e.target.value;
//     setError((prev) => ({ ...prev, brand: false }));
//     setSelectedBrand(data);
//   });

//   const handleSelectCategory = useCallback((e) => {
//     const data = e.target.value;
//     setError((prev) => ({ ...prev, category: false }));
//     setSelectedCategory(data);
//   }, []);

//   const fetchTypes = useCallback(async () => {
//     const res = await get_types();
//     if (res?.data) {
//       const filtertypes = res?.data?.filter((i) => i?.is_deleted === false);
//       setTypes(filtertypes);
//     }
//   }, []);

//   console.log("selectedSizeCategory", selectedSizeCategory)
//   useEffect(() => {
//     if (disableCategory) {
//       // setSelectedSizeCategory(SizeCategory);
//       // console.log("Region +++ ",Region , region);
//       const defaultExists = Region?.flat()?.[0];
//       // console.log("default exists",defaultExists)
//       if (defaultExists == 0) {
//         const reg = [
//           {
//             region: "Default",
//             region_ar: "پیش فرض",
//             id: 0,
//           },
//         ];
//         // console.log("check ",reg)
//         setSelectedRegion(reg);
//         return;
//       }
//       const reg = Region?.flat()?.map((i) => region?.find((ii) => ii?.id == i));
//       setSelectedRegion(reg);
//       // console.log("Region --- ",reg)
//     }
//     //  setSelectedRegion(reg)
//   }, [disableCategory, region]);

//   // console.log("SECLTED REGIONS",selectedRegion)

//   const handleAddSizesApi = async () => {
//     let payload = {};
//     const checkDublicate = frontTableData?.find(
//       (i) =>
//         i?.gender_id == selectedGender &&
//         i?.type_id == selectedCategory &&
//         i?.brand_id == selectedBrand
//     );
//     // if (checkDublicate) {
//     //   toast.error("This pair already exist ! Select different pair");
//     //   return;
//     // }

//     if (defaultText) {
//       payload = {
//         size: selectedSizeCategory?.map((i) => ({
//           gender_id: selectedGender,
//           type_id: selectedCategory,
//           brand_id: selectedBrand,
//           category_id: i?.id,
//            category_ids:selectedSizeCategory?.map(i=>({id:i?.id , category_name:i?.region})),
//           region_id: selectedRegion?.map((i) => i?.id),
//           size_text: [
//             selectedRegion?.map((i) => ({ text: "s", text_ar: "س", region: i?.id })),
//           ],
//         })),
//       };

//       // return;
//     } else {
//       payload = {
//         size: savedSizes?.map((i) => ({
//           gender_id: selectedGender,
//           type_id: selectedCategory,
//           brand_id: selectedBrand,
//           category_id: String(i?.category_id),
//           region_id: selectedRegion?.map((i) => i?.id),
//           size_text: [i?.size_text],
//         })),
//       };
//     }
//     console.log("payload is  ", payload);

//     const res = await add_sizes(payload);
//     if (res) {
//       // handleGetSize(selectedCategory);
//       // setAddSizesLines([]);
//       setApiCall((prev) => !prev);
//       setEditRow(false);
//       setOpen(false);
//       setDefaultText(false);
//       frontSelectedBrand("");
//       frontSelectedCategory("");
//       frontSelectedGender("");
//       setDisableCategory(false);
//       setSelectedSizeCategory([]);
//       setSelectedRegion([]);
//     }
//   };

//   const handleEditSizesApi = async()=>{
//       //  const  payload = savedSizes?.map((i) => ({
//       //     gender_id: String(selectedGender),
//       //     type_id: String(selectedCategory),
//       //     brand_id: String(selectedBrand),
//       //     category_id: String(i?.category_id),
//       //      size_id:String(i?.size_id),
//       //     region_id: selectedRegion?.map((i) => i?.id),
//       //     size_text: i?.size_text,
//       //   }));

//       const payload = {
//         new_type_id:selectedCategory,
//         new_brand_id:selectedBrand,
//        new_gender_id:selectedGender,
//          old_type_id:Category,
//           old_brand_id:Brand,
//        old_gender_id:Gender

//       }
//       console.log(" payloa dof new and old",payload);

//     const res = await edit_sizes_features(payload);
//     if(res)
//     {
//       setApiCall((prev) => !prev);
//       setOpen(false);
//       setEditRow(false);
//       setDefaultText(false);
//       frontSelectedBrand("");
//       frontSelectedCategory("");
//       frontSelectedGender("");
//       setDisableCategory(false);
//       setSelectedSizeCategory([]);
//       setSelectedRegion([]);
//     }

//       console.log("payload",payload);

//   }

//   const handleGetSize = useCallback(async (cat, brand, gender) => {
//     const res = await size_with_price(cat, brand, gender);
//     const filterData = res?.data?.filter((i) => !i?.size_deleted);
//     const unique = [];
//     filterData?.forEach((i) => {
//       if (!unique?.find((ii) => ii?.id == i?.category_id)) {
//         unique.push({
//           id: i?.category_id,
//           region: i?.category_name || "Default",
//           region_ar: i?.category_name_ar
//         });
//       }
//     });
//     console.log("filtere category", unique);
//     setSelectedSizeCategory(unique || []);

//     setSavedSizes(filterData);
//   }, []);

//   const handleSelectRegion = (e) => {
//     const value = JSON.parse(e.target.value);

//     if (value?.id == 0) {
//       toast.warning("Incase of Default only one value can be accepted");
//       setSelectedRegion([value]);
//       return;
//     }

//     setSelectedRegion((prev) => {
//       const defaultValue = selectedRegion?.find((i) => i?.id == 0);
//       if (defaultValue) return [value];
//       const exists = prev?.find((r) => r.id === value.id);
//       if (exists) return prev;

//       return [...prev, value];
//     });
//   };

//   const handleSelectSizeCategory = (e) => {
//     const value = JSON.parse(e.target.value);
//     if (value?.id == 0) {
//       toast.warning("Incase of Default only one value can be accepted");
//       setSelectedSizeCategory([value]);
//       return;
//     }

//     setSelectedSizeCategory((prev) => {
//       const defaultValue = selectedSizeCategory?.find((i) => i?.id == 0);
//       if (defaultValue) return [value];
//       const exists = prev.find((r) => r.id === value.id);
//       if (exists) return prev;

//       return [...prev, value];
//     });
//   };

//   const handleRemoveRegion = (id) => {
//     const removeRegion = selectedRegion?.filter((i) => i?.id != id);
//     setSelectedRegion(removeRegion);
//   };

//   const handleRemoveSizeCategory = (id) => {
//     const removeCategory = selectedSizeCategory?.filter((i) => i?.id != id);
//     setSelectedSizeCategory(removeCategory);
//   };

//   useEffect(() => {
//     handleGender();
//     handleBrands();
//     handleSizeCategory();
//     handleRegion();
//     fetchTypes();
//     if (disableCategory) handleGetSize(Category, Brand, Gender);
//   }, []);
//   useEffect(() => {
//     if (disableCategory) {
//       setError((prev) => ({ ...prev, category: false }));

//       // setSelectedCategory([SizeCategory]);
//       // setSelectedSizeCategory
//     }
//   }, [disableCategory]);

//   useEffect(()=>{
//   if(editRow)
//   {
//     setSelectedCategory(Category);
//     setSelectedBrand(Brand);
//     setSelectedGender(Gender);
//   }
//   },[editRow])

//   console.log("selcted lang", language)

//   return (
//     <Modal open={open} onClose={() => setOpen(false)}>
//       <ModalDialog
//         sx={{
//           padding: 4,
//           width: {
//             xs: "90vw",
//             sm: "600px",
//             md: "600px",
//             lg: "600px",
//           },
//         }}
//       >
//         <div className="d-flex justify-content-between align-items-center">
//           <DialogTitle>
//             {defaultText}
//           </DialogTitle>
//           {
//             <div className="d-flex justify-content-end gap-1">
//               {lang?.map((value, index) => (
//                 <button
//                   key={index}
//                   onClick={() => setLang(value)}
//                   className={`btn btn-sm rounded-pill d-flex align-items-center gap-2 px-3
//       ${language === value
//                       ? "btn-primary active-lang hindi-btn text-white"
//                       : "hindi-btn"
//                     }`}
//                 >
//                   {value}
//                 </button>
//               ))}
//             </div>
//           }
//         </div>
//         <div>
//           <p className="mb-0 fw-bold my-2">
//             Product Category<span className="text-danger">*</span>
//           </p>
//           <select
//             className="form-select cursor-pointer"
//             value={selectedCategory}
//             onChange={handleSelectCategory}
//             defaultValue={""}
//           >
//             <option value="" disabled>
//               {language == "English" ? "Select Category" : "دسته را انتخاب کنید"}
//             </option>
//             {types?.map((type) => (
//               <option
//                 className=" text-capitalize cursor-pointer text-capitalize"
//                 key={type.id}
//                 value={type?.id}
//               >
//                 {language == "English" ? type?.type_name : type.name_ar || type?.type_name}
//               </option>
//             ))}
//           </select>
//         </div>

//         <div>
//           <p className="m-0 fw-bold ">
//             {" "}
//             Gender<span className="text-danger">*</span>
//           </p>
//           <select
//             className="form-select cursor-pointer"
//             value={selectedGender}
//             onChange={handleSelectGender}
//             defaultValue={""}
//           >
//             <option value="" disabled>
//               {language == "English" ? "Select Gender" : "اختر الجنس"}
//             </option>
//             {/* <option value="1">
//               men
//             </option>
//             <option value="2">Women</option> */}
//             {genders?.map((i) => (
//               <option value={i?.id} className="cursor-pointer">
//                 {language == "English" ? i?.name : i.name_ar ||i?.name }
//               </option>
//             ))}
//           </select>
//         </div>
//         <div>
//           <p className="m-0 fw-bold">
//             {" "}
//             Brands<span className="text-danger">*</span>
//           </p>
//           <select
//             className="form-select cursor-pointer"
//             value={selectedBrand}
//             onChange={handleSelectBrand}
//             defaultValue={""}
//           >
//             <option value="" disabled>
//               {language == "English" ? "Select Brand" : "نام تجاری را انتخاب کنید"}
//             </option>
//             <option value="0">
//               {language == "English" ? "Default" : "پیش فرض"}
//             </option>
//             {brands?.map((i) => (
//               <option value={i?.id} className="cursor-pointer">
//                 {language == "English" ? i?.brand_name : i?.brand_name_ar || i?.brand_name}
//               </option>
//             ))}
//           </select>
//         </div>
//         {/* SIZE CATEGORY START  */}
//         { <div>
//           <p className="m-0 fw-bold">
//             Category <span className="text-danger">*</span>
//           </p>

//           <select
//             className="form-select cursor-pointer"
//             onChange={handleSelectSizeCategory}
//             value={""}
//          disabled={disableCategory}
//           >
//             <option value="" disabled>
//               {language == "English" ? "Select Category" : "دسته را انتخاب کنید"}
//             </option>
//             <option value={JSON.stringify({ id: 0, region: "Default", region_ar: "پیش فرض" })}>
//               {language == "English" ? "Default" : "پیش فرض"}
//             </option>

//             {sizeCategory?.map((i) => {
//               const isSelected = selectedSizeCategory?.some(
//                 (r) => r.id === i.id
//               );

//               return (
//                 <option
//                   key={i.id}
//                   value={JSON.stringify({ id: i.id, region: i.category_name, region_ar: i?.category_name_ar })}
//                   disabled={isSelected}
//                   className="cursor-pointer"
//                 >
//                   {language == "English" ? i.category_name : i?.category_name_ar || i.category_name}
//                 </option>
//               );
//             })}
//           </select>

//           <div className=" d-flex flex-wrap gap-3 mt-3 position-relative">
//             {selectedSizeCategory?.map((i) => (
//               <button
//                 key={i.id}
//                 className=" border-1 border-dark rounded-2  bg-transparent px-2 py-1"
//               >
//                 {language == "English" ? i.region : i?.region_ar|| i.region || i?.category_name_ar}
//                 {!disableCategory && (
//                   <i
//                     class="bi bi-x-circle-fill text-danger position-absolute cursor-pointer delete-region"
//                     onClick={() => {
//                       handleRemoveSizeCategory(i?.id);
//                     }}
//                   ></i>
//                 )}
//                   {/* {editRow && (
//                   <i
//                     class="bi bi-x-circle-fill text-danger position-absolute cursor-pointer delete-region"
//                     onClick={() => {
//                       handleRemoveSizeCategory(i?.id);
//                     }}
//                   ></i>
//                 )} */}
//               </button>
//             ))}
//           </div>
//         </div>
// }

//         {/* SIZE CATEGORY END  */}
//         {/* REGION START */}
//        {<div>
//           <p className="m-0 fw-bold">
//             Region <span className="text-danger">*</span>
//           </p>

//           <select
//             className="form-select cursor-pointer"
//             onChange={handleSelectRegion}
//             value=""
//             disabled={disableCategory}
//           >
//             <option value="" disabled>
//               {language == "English" ? "Select Region" : "منطقه را انتخاب کنید"}
//             </option>
//             <option value={JSON.stringify({ id: 0, region: "Default", region_ar: "پیش فرض" })}>
//               {language == "English" ? "Default" : "پیش فرض"}
//             </option>

//             {region?.map((i) => {
//               const isSelected = selectedRegion?.some((r) => r?.id === i?.id);

//               return (
//                 <option
//                   key={i.id}
//                   value={JSON.stringify({ id: i.id, region: i.region, region_ar: i?.region_ar })}
//                   disabled={isSelected}
//                   className="cursor-pointer"
//                 >
//                   {language == "English" ? i.region : i?.region_ar || i.region }
//                 </option>
//               );
//             })}
//           </select>

//           <div className=" d-flex flex-wrap gap-3 mt-3 position-relative">
//             {selectedRegion?.map((i) => (
//               <button
//                 key={i?.id}
//                 className="border-1 border-dark rounded-2  bg-transparent px-2 py-1"
//               >
//                 {language == "English" ? i?.region : i?.region_ar || i?.region}
//                 {!disableCategory && (
//                   <i
//                     class="bi bi-x-circle-fill text-danger position-absolute cursor-pointer delete-region"
//                     onClick={() => handleRemoveRegion(i?.id)}
//                   ></i>
//                 )}
//                 {/* {editRow && (
//                   <i
//                     class="bi bi-x-circle-fill text-danger position-absolute cursor-pointer delete-region"
//                     onClick={() => handleRemoveRegion(i?.id)}
//                   ></i>
//                 )} */}
//               </button>
//             ))}
//           </div>
//         </div>}
//         {/* REGION END */}

//         {/* {defaultText && <div>
//         <p className="m-0 fw-bold">
//             {" "}
//          Default Text
//           </p>
//           <input value={text} onChange={(e) => setText(e.target.value)} className="form-control"/>
//         </div>
//         } */}

//         <div className="text-end">
//           <button
//             className="btn btn-primary mt-2 "
//             onClick={editRow? handleEditSizesApi:handleAddSizesApi}
//             disabled={editRow? "":
//               error?.gender ||
//               error?.category ||
//               error?.brand ||
//               selectedSizeCategory.length === 0 ||
//               selectedRegion.length === 0
//             }
//           >
//             Submit
//           </button>
//         </div>
//       </ModalDialog>
//     </Modal>
//   );
// };

// export default CustomModal;
